import { UserOrderFulfilmentModel } from '../../data/models';
import { GetUserFulfilmentRateUseCase, ProductLockRequestRepositoryContract } from '../types';

export const getUserFulfilmentRateUseCase: GetUserFulfilmentRateUseCase = async (
  repository: ProductLockRequestRepositoryContract,
): Promise<UserOrderFulfilmentModel> => {
  return repository.userFulfilmentRate();
};
